export const throwClientLoadingError = () => {
  const msg = `[Analytics] Segment client failed to load`;
  throw new Error(msg);
};

export const throwIdentifyTimedOut = () => {
  const msg = `[Analytics] Segment.identify timed out after 10s`;
  throw new Error(msg);
};

export const throwNoContextError = () => {
  const msg = `[Analytics] Missing Context,
    "requireViewContext" is set to "true" but no "ANALYTICS_CONTEXT" found.
    https://github.com/Recruitee/recruitee/blob/master/libs/analytics/README.md#context
    
    
  `;

  throw new Error(msg);
};

export const throwReservedContextPropertyError = () => {
  const msg = `[Analytics] "context" property misused
    "viewContext" is reserved property, it should be provided as Injection token.

    https://github.com/Recruitee/recruitee/blob/master/libs/analytics/README.md#context
    
    
  `;

  throw new Error(msg);
};
